module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/049-tunisia-50f613515dc32f99009d935a344e8e1e.svg";